import { render, staticRenderFns } from "./NewCategoryProperty.vue?vue&type=template&id=4bb86753&scoped=true&"
import script from "./NewCategoryProperty.vue?vue&type=script&lang=js&"
export * from "./NewCategoryProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb86753",
  null
  
)

export default component.exports